export const LIMIT_TYPES = [
  { value: 0, text: 'Default' },
  { value: 1, text: 'VIPlimit1' },
  { value: 2, text: 'VIPlimit2' },
  { value: 3, text: 'VIPlimit3' }
]

export const getLimitTypeText = limitType => {
  const type = LIMIT_TYPES.find(t => t.value === limitType)
  return type ? type.text : `VIPlimit${limitType}`
}

export const isDefaultLimitType = limitType => {
  return limitType === 0 || limitType === null || limitType === undefined
}
